import { render } from "./ScrollToTopButton.vue?vue&type=template&id=651fff23&scoped=true"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"

import "./ScrollToTopButton.vue?vue&type=style&index=0&id=651fff23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651fff23"]])

export default __exports__